<template>
    <CompanyBoxContent v-if="dph" :title="`${$t('company.currentAccounts')} (${$t('company.byDphRegister')}):`">
        <template #data>
            <div class="table-responzive">
                <table class="table table-hover">
                    <thead class="table_head">
                        <tr>
                            <th>{{ $t("company.bankNumber") }}</th>
                            <th>{{ $t("company.bankName") }}</th>
                            <th>{{ $t("company.validityFrom") }}</th>
                            <th>{{ $t("company.validityTo") }}</th>
                        </tr>
                    </thead>
                    <tbody class="align-middle">
                        <!-- ACTUAL ACCOUNTS -->
                        <tr v-for="(account, index) in dph.bankovniUcty" :key="index">
                            <td>
                                <span v-if="account.cisloUctu" style="word-break: break-all;">{{
                                    account.cisloUctu }}</span>
                            </td>
                            <td>
                                <span v-if="account.banka" class="w-100">{{ account.banka }}</span>
                                <span v-else>{{ $t('general.unknown') }}</span>
                            </td>
                            <td>
                                <span v-if="account.datumUctu" class="w-100">
                                    <i18n-d tag="span" :value="new Date(account.datumUctu)"></i18n-d>
                                </span>
                            </td>
                            <td>
                                <span class="w-100">
                                    {{ $t('company.stillValid') }}
                                </span>
                            </td>
                        </tr>
                        <!-- OLD ACCOUNTS -->
                        <tr v-for="(oldAccount, index) in dph.historieBankovnichUctu" :key="index">
                            <td>
                                <span v-if="oldAccount.cisloUctu" style="word-break: break-all;">{{
                                    oldAccount.cisloUctu }}</span>
                            </td>
                            <td>
                                <span v-if="oldAccount.banka" class="w-100">{{ oldAccount.banka }}</span>
                                <span v-else>{{ $t('general.unknown') }}</span>
                            </td>
                            <td>
                                <span v-if="oldAccount.datumZverejneni" class="w-100">
                                    <i18n-d tag="span" :value="new Date(oldAccount.datumZverejneni)"></i18n-d>
                                </span>
                            </td>
                            <td>
                                <span v-if="oldAccount.datumUkonceniZverejneni" class="w-100">
                                    <i18n-d tag="span" :value="new Date(oldAccount.datumUkonceniZverejneni)"></i18n-d>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </CompanyBoxContent>
</template>

<script>
import CompanyBoxContent from "@/components/CompanyBoxContent.vue"

export default {
    props: {
        company: {
            type: Object,
            required: true
        }
    },
    components: {
        CompanyBoxContent,
    },
    data() {
        return {

        }
    },
    computed: {
        dph() {
            return this.company.dph ? this.company.dph : null;
        },
        oldAccounts() {
            if (this.company && this.company.dph) {
                return this.company.dph.historieBankovnichUctu || [];
            }
            return [];
        }
    },
    methods: {
        isValidDate(dateString) {
            // Check if the date string can be converted to a valid Date object and not shows Invalid date
            const date = new Date(dateString);
            return !isNaN(date.getTime());
        },
        formatDate(dateString) {
            // Format the date if valid
            const date = new Date(dateString);
            return date.toLocaleDateString();
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.title {
    padding: 0 0 5px 20px;

    h3 {
        font-weight: 700;
        font-size: clamp(18px, 1.8vw, 24px);
    }
}

.inner {
    border-radius: $radius-lg;
}

.bg {
    background-color: $grey;
}
</style>